import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { FONTS } from '../constants/Fonts';
import { ROUTE_ENUM } from '../routes/RoutesConstant';
import './GameScreenTopBar.css';

/**
 * Figma 18011:21879 — game nav bar with 20px side margins.
 * Center brand: icon + name (Figma 17742:25897 + 25896 for RapHousie).
 */
const GameScreenTopBar = ({
  title,
  centerLogoSrc,
  centerLogoAlt = '',
  brandIconSrc,
  brandName,
  brandGradientFrom,
  brandGradientTo,
  backLabel = 'Back to Game Zone',
  onBack,
  fullBleed = false,
  variant = 'default',
  centerAccessory = null,
  hideBack = false,
}) => {
  const navigate = useNavigate();

  const handleBack =
    onBack ||
    (() => {
      navigate(ROUTE_ENUM.SELECT_GAME.routePath);
    });

  const showBrand = Boolean(brandIconSrc || brandName) && !title;
  const isLeaderboard = variant === 'leaderboard';
  const isPublicHeader = hideBack;

  return (
    <header
      className={`game-screen-topbar${fullBleed ? ' game-screen-topbar--bleed' : ''}${isLeaderboard ? ' game-screen-topbar--leaderboard' : ''}${isPublicHeader ? ' game-screen-topbar--public' : ''}`}
      data-node-id={isPublicHeader ? '20780:14944' : undefined}
    >
      {isPublicHeader ? (
        title ? (
          <h1
            className="game-screen-topbar__event"
            style={{ fontFamily: FONTS.INTER_EXTRABOLD }}
            data-node-id="20780:14951"
          >
            {title}
          </h1>
        ) : (
          <span className="game-screen-topbar__event-spacer" />
        )
      ) : (
        <button type="button" className="game-screen-topbar__back" onClick={handleBack}>
          <span className="game-screen-topbar__back-icon" aria-hidden="true">
            <img src={IMAGE_CONSTANTS.V2_REVAMPED_LOBBY_BACK_ARROW} alt="" />
          </span>
          <span className="game-screen-topbar__back-label">{backLabel}</span>
        </button>
      )}

      {isPublicHeader ? null : (
        <div className="game-screen-topbar__center">
          {showBrand ? (
            <div className="game-screen-topbar__brand" data-node-id="17742:25897">
              {brandIconSrc ? (
                <img
                  className="game-screen-topbar__brand-icon"
                  src={brandIconSrc}
                  alt=""
                  width={94}
                  height={72}
                />
              ) : null}
              {brandName ? (
                <span
                  className="game-screen-topbar__brand-name"
                  style={{
                    fontFamily: FONTS.INTER_EXTRABOLD,
                    backgroundImage: `linear-gradient(180deg, ${brandGradientFrom || '#3668EF'} 0%, ${brandGradientTo || '#134BEA'} 100%)`,
                  }}
                  data-node-id="17742:25896"
                >
                  {brandName}
                </span>
              ) : null}
            </div>
          ) : centerLogoSrc ? (
            <img
              className="game-screen-topbar__center-logo"
              src={centerLogoSrc}
              alt={centerLogoAlt || title || ''}
            />
          ) : (
            <h1
              className="game-screen-topbar__title"
              style={{ fontFamily: FONTS.INTER_EXTRABOLD }}
            >
              {title || 'ROOM NAME'}
            </h1>
          )}
          {centerAccessory}
        </div>
      )}

      <span className="game-screen-topbar__logo-well" data-node-id="20780:14953">
        <img
          className="game-screen-topbar__logo"
          src={IMAGE_CONSTANTS.V2_HEADER_LOGO}
          alt="Rapchik"
        />
      </span>
    </header>
  );
};

GameScreenTopBar.propTypes = {
  title: PropTypes.string,
  centerLogoSrc: PropTypes.string,
  centerLogoAlt: PropTypes.string,
  brandIconSrc: PropTypes.string,
  brandName: PropTypes.string,
  brandGradientFrom: PropTypes.string,
  brandGradientTo: PropTypes.string,
  backLabel: PropTypes.string,
  onBack: PropTypes.func,
  fullBleed: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'leaderboard']),
  centerAccessory: PropTypes.node,
  hideBack: PropTypes.bool,
};

export default GameScreenTopBar;
